import { __values } from "tslib";
var supportsPreventScrollCached = null;
function supportsPreventScroll() {
    if (supportsPreventScrollCached === null) {
        supportsPreventScrollCached = false;
        try {
            var element = document.createElement('div');
            element.focus({
                get preventScroll() {
                    supportsPreventScrollCached = true;
                    return true;
                },
            });
        }
        catch (e) {
            // ignore
        }
    }
    return supportsPreventScrollCached;
}
function getScrollableElements(element) {
    var scrollableElements = [];
    var rootScrollingElement = document.scrollingElement || document.documentElement;
    var parent = element.parentNode;
    while (parent instanceof HTMLElement && parent !== rootScrollingElement) {
        if (parent.offsetHeight < parent.scrollHeight || parent.offsetWidth < parent.scrollWidth) {
            scrollableElements.push({
                element: parent,
                scrollTop: parent.scrollTop,
                scrollLeft: parent.scrollLeft,
            });
        }
        parent = parent.parentNode;
    }
    if (rootScrollingElement instanceof HTMLElement) {
        scrollableElements.push({
            element: rootScrollingElement,
            scrollTop: rootScrollingElement.scrollTop,
            scrollLeft: rootScrollingElement.scrollLeft,
        });
    }
    return scrollableElements;
}
function restoreScrollPosition(scrollableElements) {
    var e_1, _a;
    try {
        for (var scrollableElements_1 = __values(scrollableElements), scrollableElements_1_1 = scrollableElements_1.next(); !scrollableElements_1_1.done; scrollableElements_1_1 = scrollableElements_1.next()) {
            var _b = scrollableElements_1_1.value, element = _b.element, scrollTop = _b.scrollTop, scrollLeft = _b.scrollLeft;
            element.scrollTop = scrollTop;
            element.scrollLeft = scrollLeft;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (scrollableElements_1_1 && !scrollableElements_1_1.done && (_a = scrollableElements_1.return)) _a.call(scrollableElements_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
export function focusWithoutScrolling(element) {
    if (supportsPreventScroll()) {
        element.focus({ preventScroll: true });
    }
    else {
        var scrollableElements = getScrollableElements(element);
        element.focus();
        restoreScrollPosition(scrollableElements);
    }
}
export function focusElement(element, preventScroll) {
    if (!element) {
        return;
    }
    try {
        if (preventScroll) {
            focusWithoutScrolling(element);
        }
        else {
            element.focus();
        }
    }
    catch (_error) {
        // Ignore
    }
}
